export default __webpack_public_path__ + "static/media/1911.1a1698c8.png";